import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useFollow } from '../hooks/useFollow';
import '../Style/SocialModal.css';
import { removeFollower } from '../api/userFollowApi';
import { useState } from 'react';

const SocialModal = ({
  isOpen,
  title,
  userList,
  setUserList,
  onClose,
  currentUserId,
  onFollowStatusChange,
  isOwnFollowersList,
}) => {
  const navigate = useNavigate();
  const { toggleFollow, loadingId } = useFollow();

  const [removingId, setRemovingId] = useState(null);

  const handleRemoveFollower = async (userId) => {
    setRemovingId(userId);
    try {
      await removeFollower(userId);
      setUserList((prev) => prev.filter((u) => u.id !== userId));
      if (onFollowStatusChange) onFollowStatusChange(userId, false);
    } catch (err) {
      console.error('Remove follower failed', err);
    } finally {
      setRemovingId(null);
    }
  };

  const handleListFollow = (user) => {
    toggleFollow(
      user.id,
      user.isFollowing,
      user.requestSent, // ✅ pass requestSent
      ({ isFollowing, requestSent }) => {
        setUserList((prev) =>
          prev.map((u) => (u.id === user.id ? { ...u, isFollowing, requestSent } : u)),
        );
        if (onFollowStatusChange) onFollowStatusChange(user.id, isFollowing, requestSent);
      },
      ({ isFollowing, requestSent }) => {
        setUserList((prev) =>
          prev.map((u) => (u.id === user.id ? { ...u, isFollowing, requestSent } : u)),
        );
      },
    );
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header-container">
          <h2 className="modal-title">{title}</h2>
          <button className="close-x" onClick={onClose}>
            &times;
          </button>
        </div>

        <div className="modal-scroll-area">
          {userList && userList.length > 0 ? (
            userList.map((u) => (
              <div key={u.id} className="user-social-row">
                <div
                  className="user-social-info"
                  onClick={() => {
                    onClose();
                    navigate(`/profile/${u.id}`);
                  }}
                >
                  <div className="profile-trigger">
                    {' '}
                    {u?.profilePicUrl ? (
                      <img
                        src={u.profilePicUrl}
                        alt="Profile"
                        className="avatar-circle avatar-img"
                        style={{ objectFit: 'cover' }}
                      />
                    ) : (
                      <div className="avatar-circle">
                        {u.firstName?.charAt(0).toUpperCase() || 'U'}
                      </div>
                    )}
                  </div>
                  <div className="user-name-details">
                    <p className="user-full-name">
                      {u.firstName} {u.lastName}
                    </p>
                  </div>
                </div>
                {String(currentUserId) !== String(u.id) && (
                  <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                    {/* Remove follower — only show on followers list */}
                    {isOwnFollowersList && (
                      <button
                        className="btn-remove-follower"
                        disabled={removingId === u.id}
                        onClick={() => handleRemoveFollower(u.id)}
                      >
                        {removingId === u.id ? '...' : 'Remove'}
                      </button>
                    )}
                    <button
                      disabled={loadingId === u.id}
                      className={u.isFollowing ? 'btn-following' : 'btn-follow-action'}
                      onClick={() => handleListFollow(u)}
                    >
                      {loadingId === u.id ? (
                        <span className="spinner-inline"></span>
                      ) : u.isFollowing ? (
                        'Following'
                      ) : u.requestSent ? (
                        'Requested'
                      ) : (
                        'Follow'
                      )}
                    </button>
                  </div>
                )}
              </div>
            ))
          ) : (
            <p className="empty-modal-text">No users found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SocialModal;
